import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default function ForgotPassword() {

    let [email, setEmail] = useState("");
    let [spin, setSpin] = useState(false);
    let [sendCode, setSendCode] = useState(false);
    let [checkVerify, setCheckVerify] = useState(false);
    let [code, setCode] = useState("");
    let [error, setError] = useState("");
    let [allusers, setAllUsers] = useState([]);
    let [state, setState] = useState(false);
    const inputRefs = useRef([]);
    let [password, setPassword] = useState({
        password1: "",
        password2: ""
    })
    let [eyeOne, setEyeOne] = useState(false);
    let [eyeTwo, setEyeTwo] = useState(false);
    let [resetCheck, setResetCheck] = useState(false);

    let handleSendLink = async (e) => {
        inputRefs.current = [];
        setCode("");
        setSendCode(false);
        setCheckVerify(false);
        setSpin(true)
        e.preventDefault();

        let res = await fetch("https://toolisobackend.vercel.app/allusers", {
            method: 'GET',
            headers: {
                "Content-Type": "Application/json"
            }
        })

        if (res.status === 200) {
            let dat = await res.json();

            setAllUsers(allusers = dat.users);
            let found = allusers.some(user => user.email === email);
            if (found) {
                let response = await fetch('https://toolisobackend.vercel.app/send-code', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ email })
                })
                if (response.status === 200) {
                    let data = await response.json();
                    setCode(code = data.code);
                    setSpin(false);
                    setSendCode(true);

                }
                else {
                    let data = await response.json();
                    setError(data.message);
                    setTimeout(() => {
                        setError("");
                    }, 2000);
                    setSpin(false);
                }
            }

            else {
                setError(`We couldn't find any account linked to the email address: ${email}.`);
                setTimeout(() => {
                    setError("");
                }, 3000);
                setSpin(false);
            }


        }
        else {

        }



    }

    const [otp, setOtp] = useState(Array(6).fill(""));


    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    let handleVerify = (e) => {

        e.preventDefault();
        setState(true);
        let fullOtp = Number(otp.join(""));
        if (fullOtp === code) {
            setSendCode(false);
            setCheckVerify(true);

        }
        else {
            setError("Wrong code, please Enter correct code")
            setTimeout(() => {
                setError("");
            }, 3000);

        }

    }

    let handlePassword = async (e) => {
        setResetCheck(true);
        e.preventDefault();
        if(password.password1.length<=6){
            setError("Password must be greater than 6 digits");
            setTimeout(() => {
                setError("");
            }, 2500);
            setResetCheck(false);
        }
        else if (password.password1 === password.password2) {

            let response = await fetch('https://toolisobackend.vercel.app/setNewPassword', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password: password.password1 })
            })


            if (response.status === 200) {
                let data = await response.json();
                setError(data.message)
                setTimeout(() => {
                    setError("");
                }, 3000);
                setResetCheck(false);
            }
            else{
                 let data = await response.json();
                setError(data.message)
                setTimeout(() => {
                    setError("");
                }, 3000);
            }

        }
        else {
            setError("The new password and confirmation do not match")
            setTimeout(() => {
                setError("");
            }, 3000);
            setResetCheck(false);
        }
    }

    return (
        <div className='signup'>
            <div className="innersignup">
                <div className="secondsignup">
                    <h1>Forgot Password</h1>
                    {
                        !state ?
                            <>
                                <input
                                    placeholder='Enter your registered email'
                                    className='inputsignup'
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                {
                                    spin ?
                                        <button className='btn1signup'>
                                            <div className="spinner"></div>
                                        </button>
                                        :
                                        <button className='btn1signup' onClick={(e) => handleSendLink(e)}>
                                            <p style={{ color: "black" }}>Send Reset Link</p>
                                            <FontAwesomeIcon icon={faArrowRight} />
                                        </button>

                                }
                            </>
                            : ""
                    }
                    {
                        sendCode ?
                            <>
                                <form className="fourthsignup" onSubmit={(e) => handleVerify(e)}>
                                    <label htmlFor="">Please enter the 6-digit security code we've sent to your email address</label>
                                    <div className="innerfourthsignup">
                                        {[...Array(6)].map((_, i) => (
                                            <input
                                                key={i}
                                                type="text"
                                                maxLength={1}
                                                value={otp[i]}
                                                onChange={(e) => handleChange(e, i)}
                                                ref={(el) => (inputRefs.current[i] = el)}
                                            />
                                        ))}
                                    </div>
                                    <button className='btn1signup'>
                                        <p style={{ color: "black" }}>Verify Code</p>
                                    </button>
                                </form>



                            </>
                            :
                            ""
                    }
                    {
                        checkVerify ?
                            <>
                                <div className="thirdsignup">
                                    <input
                                        placeholder='Enter New Password'
                                        className='inputsignup'
                                        type={`${eyeOne ? 'text' : 'password'}`}
                                        value={password.password1}
                                        onChange={(e) => setPassword({ ...password, password1: e.target.value })}
                                    />
                                    {
                                        eyeOne ?
                                            <p className='eyecheck' onClick={() => setEyeOne(false)}>🔒</p>
                                            :
                                            <p className='eyecheck' onClick={() => setEyeOne(true)}>👁️</p>
                                    }
                                </div>
                                <div className="thirdsignup">
                                    <input
                                        placeholder='Confirm New Password'
                                        className='inputsignup'
                                        type={`${eyeTwo ? 'text' : 'password'}`}
                                        value={password.password2}
                                        onChange={(e) => setPassword({ ...password, password2: e.target.value })}
                                    />
                                    {
                                        eyeTwo ?
                                            <p className='eyecheck' onClick={() => setEyeTwo(false)}>🔒</p>
                                            :
                                            <p className='eyecheck' onClick={() => setEyeTwo(true)}>👁️</p>
                                    }
                                </div>
                                {
                                    resetCheck ?
                                        <button className='btn1signup'>
                                            <div className="spinner"></div>
                                        </button>
                                        :
                                        <button className='btn1signup' onClick={(e) => handlePassword(e)}>
                                            <p style={{ color: "black" }}>Reset Password</p>
                                        </button>
                                }
                            </>
                            : ""
                    }
                    <p style={{ color: "red" }}>{error}</p>
                    <div className="linesignup">
                        <div></div>
                        <p>or</p>
                        <div></div>
                    </div>
                    <p>Remember your password? <Link to={'/login'}>Login</Link></p>
                </div>
            </div>
        </div>
    )
}
